import { Link } from 'react-router-dom';

interface RelatedGuide {
  title: string;
  path: string;
  description: string;
}

interface RelatedGuidesProps {
  guides: RelatedGuide[];
}

export default function RelatedGuides({ guides }: RelatedGuidesProps) {
  return (
    <section className="py-12 bg-gray-50">
      <div className="max-w-4xl mx-auto px-4">
        <h2 className="text-3xl font-bold text-gray-900 mb-8">Related Guides</h2>
        <div className="grid md:grid-cols-2 gap-6">
          {guides.map((guide) => (
            <Link
              key={guide.path}
              to={guide.path}
              className="bg-white p-6 rounded-lg shadow-sm hover:shadow-md transition cursor-pointer group"
            >
              <h3 className="text-xl font-bold text-gray-900 mb-2 group-hover:text-teal-500 transition">
                {guide.title}
              </h3>
              <p className="text-gray-600 text-sm">{guide.description}</p>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
